import React from 'react';
import { Box, Typography, useTheme } from '@material-ui/core';
import TitleMLStyled from './TitleMLStyles';

export default ({ title, fontSize }) => {
  const theme = useTheme();
  return (
    <TitleMLStyled theme={theme} fontSize={fontSize}>
      <Box>
        <Typography variant="body1" className="title-style">
          {title}
        </Typography>
      </Box>
    </TitleMLStyled>
  );
};
